import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import "../css/modal.css";
import bombillo from "../assets/images/Vector.png";
import Select from "react-select";
export const CiudadModal = (props) => {
  window.scrollTo(0, 0);
  const [value, setValue] = React.useState([]);
  const [ciudadSeleccionadda, setCiudadSeleccionada] = useState("");
  const options = props.dataCities;
  return (
    <div>
      <Modal {...props} size="lg" centered>
        <ModalBody>
          <h4 className="text-header-modal">Ubicación</h4>
          <div className="container-modal-content">
            <p className="text-select-region">
              Selecciona tu ubicación para encontrar la oficina que necesites.
            </p>
            <div style={{ display: "flex", width: "100%", height: "100%" }}>
              <Select
                name="optionsCity"
                id="optionsCity"
                className="optionsCity"
                placeholder="Selecciona tu ciudad"
                options={options}
                value={ciudadSeleccionadda}
                onChange={(selec) => setCiudadSeleccionada(selec)}
                getOptionLabel={(option) => option.Ciudad}
                getOptionValue={(option) => option.QueryCiudad}
              />
            </div>
            <div className="location-warning-mobile">
              <img
                src={bombillo}
                className="img-bombillo-warning"
                alt="imagen bombillo"
              />{" "}
              <p className="text-location-warning">
                Activa la ubicación de tu dispositivo para una mejor
                experiencia.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                paddingTop: "2rem",
              }}
            >
              <button
                class="btn btn-primary button-next"
                type="submit"
                onClick={() => {
                  props.handleCiudad(ciudadSeleccionadda);
                }}
                disabled={ciudadSeleccionadda ? false : true}
              >
                Continuar
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
